<style scoped lang="less">
.amount {
    font-size: 16px;
    font-weight: bold;
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-date-picker size="mini" style="width: 250px" @change="refetchData" v-model="date" type="daterange"
                range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            <el-input @input="refetchData" class="margin-l" size="mini" style="width: 200px;" placeholder="手机号、姓名"
                clearable @clear="refetchData" prefix-icon="el-icon-search" v-model="user"
                @keyup.native.enter="refetchData"></el-input>
            <!-- <el-input size="mini" style="width: 200px;" placeholder="核销备注" clearable @clear="refetchData"
                prefix-icon="el-icon-search" v-model="remarks" @keyup.native.enter="refetchData"></el-input> -->
            <el-button size="mini" class="margin-l" type="primary" @click.stop="refetchData">搜索</el-button>
            <!-- <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button> -->
            <span class="margin-l amount" style="margin-left:30px">
                充值: <span class="color-success">+{{totalAmount1}}</span>
            </span>
            <span class="margin-l amount">
                消费: <span class="color-danger">-{{totalAmount2}}</span>
            </span>
            <span class="margin-l amount">
                余额: <span class="color-warning">{{Math.round(totalAmount1*100-totalAmount2*100)/100}}</span>
            </span>
        </div>
        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini" @filter-change="handleFilter">
                <el-table-column type="index" align="center" width="45"></el-table-column>
                <el-table-column label="录入日期" align="center" width="130">
                    <template slot-scope="scope" v-if="scope.row.date">
                        {{scope.row.date | fmt-time}}
                    </template>
                </el-table-column>
                <el-table-column label="用户" width="170">
                    <template slot-scope="scope" v-if="scope.row.user">
                        {{scope.row.user.phone}} {{scope.row.user.name}}
                    </template>
                </el-table-column>
                <el-table-column label="金额" align="center" width="100" :filters="[
                        { text: '充值', value: '充值' },
                        { text: '消费', value: '消费' },
                    ]" :filter-multiple="false" column-key="type">
                    <template slot-scope="scope">
                        <div class="amount" :style="calcAmount(scope.row.amount)">
                            {{scope.row.amount > 0 ? `+${scope.row.amount}` : scope.row.amount}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="余额" align="center" width="130">
                    <template slot-scope="scope">
                        <div class="amount color-info">实时: {{calcSurplus(scope.row.user._id)}}</div>
                    </template>
                </el-table-column>
                <el-table-column :filters="stores" :filter-multiple="false" column-key="store" label="店铺" align="center"
                    width="100">
                    <template slot-scope="scope" v-if="scope.row.store">
                        {{scope.row.store.name}}
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remarks" width="140"></el-table-column>
                <el-table-column label="操作" min-width="120">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-value ref="edit" @fetch-data="fetchData"></dialog-edit-value>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditValue from "../components/dialog/dialogEditValue";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import dayjs from "dayjs";

export default {
    components: {
        DialogEditValue,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            date: [new Date(), new Date()],
            user: "",
            remarks: "",
            surplusHash: {},
            type: "",
            store: "",
            stores: [],
            totalAmount1: 0,
            totalAmount2: 0,
        };
    },
    created() {
        this.fetchStores();
    },
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() { },
    methods: {
        handleFilter(column) {
            if (column.type) {
                if (column.type.length) {
                    this.type = column.type[0];
                } else {
                    this.type = "";
                }
            }
            if (column.store) {
                if (column.store.length) {
                    this.store = column.store[0];
                } else {
                    this.store = "";
                }
            }
            this.refetchData();
        },
        calcAmount(amount) {
            if (amount < 0) {
                return "color:#f56c6c";
            } else {
                return "color:#67c23a";
            }
        },
        async fetchStores() {
            let res = await HttpClient.post("/restful", {
                model: "Store",
                sort: {
                    _id: -1,
                },
                pageSize: 1000,
                pageNum: 0,
            });
            this.stores = res.result.map((it) => {
                return { text: it.name, value: it._id };
            });
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                master: true,
            };
            if (this.user) {
                cond.user = this.user;
            }
            if (this.remarks) {
                cond.remarks = this.remarks;
            }
            if (this.type) {
                cond.type = this.type;
            }
            if (this.date && this.date.length) {
                let [start, end] = this.date;
                cond = {
                    ...cond,
                    date: {
                        $gte: dayjs(start).startOf("day"),
                        $lte: dayjs(end).endOf("day"),
                    },
                };
            }
            if (this.store) {
                cond = { ...cond, store: this.store };
            }
            let res = await HttpClient.post("/value/getAll", cond);
            this.data = res.result;
            this.table.submitTotal(res.count);
            this.fetchSurplus();

            this.totalAmount1 = Math.abs(res.totalAmount1);
            this.totalAmount2 = Math.abs(res.totalAmount2);
        },
        async fetchSurplus() {
            if (!this.data.length) return;
            let res = await HttpClient.post("/value/getSurplus", {
                ids: this.data.map((it) => it.user._id).join("|"),
            });
            this.surplusHash = res;
        },
        calcSurplus(userId) {
            if (this.surplusHash.hasOwnProperty(userId)) {
                return this.surplusHash[userId];
            } else {
                return "-";
            }
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            let userId = item.user._id;
            await actionConfirm();
            await removeModel("Value", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
